import { useTranslation } from "react-i18next";
import {useNavigate, useOutletContext} from "react-router-dom";
import { useEffect, useState } from "react";
import { RiderProfileLayoutContextInterface } from "./RiderProfileLayout";
import { useLoading } from "../../Context/LoadingProvider";
import {patrollerService} from "../../Api/Services/PatrollerService";
import IdVerificationStep from "./StartCheckSteps/IdVerificationStep";
import VehicleVerificationStep from "./StartCheckSteps/VehicleVerificationStep";
import GearCheckStep from "./StartCheckSteps/GearCheckStep";
import QuestionerStep from "./StartCheckSteps/QuestionerStep";
import StickerVerificationStep from "./StartCheckSteps/StickerVerificationStep";

interface CheckHistoryProps {
}

const StartCheck: React.FunctionComponent<CheckHistoryProps> = () => {
  const { t } = useTranslation();
  const { startLoading, finnishLoading } = useLoading();
  const navigate = useNavigate();
  const {
    setSubTitle,
    rider,
      setShowProfileInfo,
      setShowTabsNavbar
  } = useOutletContext<RiderProfileLayoutContextInterface>();

  const [step, setStep] = useState<number>(-1);
    const [totalSteps, setTotalSteps] = useState<number>(4);
    const [progressStep, setProgressStep] = useState<number>(0);


    const [needsVehicleCheck, setNeedsVehicleCheck] = useState<number>(0);
  const [continueAfterFakeId, setContinueAfterFakeId] = useState<boolean>(true);
  const [needsStickerCheck, setneedsStickerCheck] = useState<number>(0);
  const [canEditSticker, setCanEditSticker] = useState<boolean>(false);

    const { setStepperValues } = useOutletContext<any>();

    useEffect(() => {
        if (progressStep > 0) {
            setStepperValues(progressStep, totalSteps);
        }
    }, [progressStep, totalSteps, setStepperValues]);


    useEffect(() => {
        startLoading('rider-select');

        patrollerService.isRiderReadyForCheck(rider.riderId)
            .then(() => {
                patrollerService.getCheckForRider(rider.riderId).then(async (check: any) => {
                    let startIndex = 0;

                    if (parseInt(check.needs_id_check) > 0 && (check.is_id_valid === null || check.is_id_valid === undefined)) {
                        startIndex = 0;
                    } else if (parseInt(check.needs_sticker_check) > 0 && (check.is_sticker_valid === null || check.is_sticker_valid === undefined)) {
                        startIndex = 1;
                    } else if (parseInt(check.needs_vehicle_check) > 0 &&
                        ((check.is_license_plate_valid === null || check.is_license_plate_valid === undefined) ||
                            (check.is_vehicle_valid === null || check.is_vehicle_valid === undefined))) {
                        startIndex = 2;
                    } else if (check.gear_information === null || check.gear_information === undefined) {
                        startIndex = 3;
                    } else {
                        startIndex = 4;
                    }

                    setNeedsVehicleCheck(parseInt(check.needs_vehicle_check));
                    setContinueAfterFakeId(check.continue_after_fake_id === 1 || check.continue_after_fake_id === '1');
                    setneedsStickerCheck(parseInt(check.needs_sticker_check));
                    setCanEditSticker(check.sticker_editable);

                    patrollerService.setCheckForRider(rider.riderId, check.id);

                    try {
                        const res: any = await patrollerService.getQuestionerCount(rider?.vehicle);
                        const questionCount = Number(res?.count ?? res ?? 0);
                        const total = 5 + (Number.isFinite(questionCount) ? questionCount : 0);
                        setTotalSteps(total);
                        setProgressStep(1);
                    } catch {
                        setTotalSteps(5);
                    }

                    setStep(startIndex);
                })
                    .finally(() => {
                        finnishLoading('rider-select');
                        setShowTabsNavbar(false);
                        setShowProfileInfo(true);
                        setSubTitle(t('T-Patroller Actions History'));
                    });
            })
            .catch(() => {
                finnishLoading('rider-select');
                navigate(`/rider/${rider.riderId}/profile`);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    useEffect(() => {
    setSubTitle();
  }, [t, setSubTitle]);

  return (
          <>

              {step === 0 && (
                  <IdVerificationStep
                      setStep={setStep}
                      setProgressStep={setProgressStep}
                      needsVehicleCheck={needsVehicleCheck}
                      continueAfterFakeId={continueAfterFakeId}
                      stickerCheck={needsStickerCheck}
                  />
              )}
              {step === 1 && (
                  <StickerVerificationStep
                      setStep={setStep}
                      setProgressStep={setProgressStep}
                      needsStickerCheck={needsStickerCheck}
                      canEditSticker={canEditSticker}
                  />
              )}

              {step === 2 && (
                  <VehicleVerificationStep
                      setStep={setStep}
                      setProgressStep={setProgressStep}
                      needsVehicleCheck={needsVehicleCheck}
                  />
              )}
              {step === 3 && (
                  <GearCheckStep
                      setStep={setStep}
                      setProgressStep={setProgressStep}
                  />
              )}
              {step === 4 && (
                  <QuestionerStep
                      setStep={setStep}
                      setProgressStep={setProgressStep}
                  />
              )}
          </>
  );
};

export default StartCheck;
